import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants/enums";
import { SocialsData } from "../../content.types";

export const requestGetSocials = async (): Promise<SocialsData> => {
  return await instance.get(ApiRoutesContent.Socials);
};
